module.exports = __webpack_public_path__ + "static/media/wind.4b835e6b.png";